import { AppEntities } from "src/config/entities";
import {DocumentService} from "./DocumentService";
import { ICustomerInvoicesDto } from "src/components/Pages/Documents/CustomerInvoices/dtos/ICustomerInvoicesDto";

export class CustomerInvoicesService extends DocumentService {
    async Clone(id: string) {
        const newObject = await this.Get(id);
        const clonedObject = {...newObject};
        return clonedObject;
    }

    async createBasedAtOrder(id: string) {
        const orderDto =
            await AppEntities.ReturnOfGoodsFromCustomers.getDataService().Get(id);
        const newCustomerInvoice: ICustomerInvoicesDto = {...orderDto};
        // newCustomerInvoice.paymentOffsets = [];
        return newCustomerInvoice;
    }
}
